import React from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import { api, onPost, onGet } from '../../../core/api3';

class AccountEditView extends React.Component {

    constructor() {
        super();
        this.state = {
            account: {},
            password: ''
        }
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        if (!this.props.isAdd) {
            onGet(api.getPlatformAccount.url, api.getPlatformAccount.params(this.props.accountId)).then(response => {
                if (response === undefined) {
                    return;
                }
                // let timestamp = (new Date()).getTime();
                // let time = moment(timestamp).format('HHDDMMYYYY')
                this.setState({ account: response });
            });
        }
    }

    onClick(type) {
        switch (type) {
            case 'confirm':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    if (this.props.isAdd) {
                        onPost(api.addPlatformAccount.url, api.addPlatformAccount.params(this.props.platformId, fields.username, fields.password, fields.tag)).then(response => {
                            if (response === undefined) {
                                return;
                            }
                            message.success('添加成功');
                            this.props.onModalFinish();
                        });
                    } else {
                        onPost(api.updatePlatformAccount.url, api.updatePlatformAccount.params(this.props.accountId, fields.password, fields.tag)).then(response => {
                            if (response === undefined) {
                                return;
                            }
                            message.success('更新成功');
                            this.props.onModalFinish();
                        });
                    }
                });
                break;
            default:
                break;
        }
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        return (
            <Modal title={this.props.isAdd ? '添加' : '编辑'} visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    {!this.props.isAdd &&
                        <div>
                            <Form.Item {...formItemLayout} label="平台名称">
                                {this.state.account.platformName}
                            </Form.Item>
                            <Form.Item {...formItemLayout} label="用户名">
                                {this.state.account.username}
                            </Form.Item>
                        </div>
                    }
                    {this.props.isAdd &&
                        <div>
                            <Form.Item {...formItemLayout} label="平台名称">
                                {this.props.platformName}
                            </Form.Item>
                            <Form.Item {...formItemLayout} label="用户名">
                                {this.props.form.getFieldDecorator('username', {
                                    rules: [{ required: true, message: '请输入用户名' }]
                                })(
                                    <Input placeholder="请输入用户名" maxLength="20" />
                                )}
                            </Form.Item>
                        </div>
                    }
                    <Form.Item {...formItemLayout} label="密码">
                        {this.props.form.getFieldDecorator('password', {
                            initialValue: this.state.password,
                            rules: [{ required: true, message: '请输入密码' }]
                        })(
                            <Input placeholder="请输入密码" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="标签">
                        {this.props.form.getFieldDecorator('tag', {
                            initialValue: this.state.account.tag,
                            rules: [{ required: true, message: '请输入标签' }]
                        })(
                            <Input placeholder="请输入标签" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={() => this.onClick('confirm')} hidden={this.props.isAdd}>确定</Button>
                        <Button type="primary" onClick={() => this.onClick('confirm')} hidden={!this.props.isAdd}>添加</Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }

}

const AccountEditModal = Form.create()(AccountEditView);
export default AccountEditModal;


// WEBPACK FOOTER //
// ./src/page/jsx/account/AccountEditModal.jsx